import { AddFilesModal, type AddFilesModalInitialTab } from '@/chat-common/components/source-dialogs/AddFilesModal'
import { kPdfOnlyFileTypeMessage } from '@/user_files/constants'

type AddFilesMatterFilesDialogProps = {
  open: boolean
  matterId: string | null
  initialSelectedIds: string[]
  initialTab?: AddFilesModalInitialTab
  onClose: () => void
  onApply: (userFileIds: string[]) => void
}

/**
 * Matter Files picker for the chronology Add Files page. Thin wrapper over the shared
 * {@link AddFilesModal}, restricted to PDFs - the only type Med Chron extracts. The shared
 * modal already gates non-completed files (processing / failed) out of selection, so this
 * wrapper only adds the PDF rule on top.
 */
export function AddFilesMatterFilesDialog({ open, matterId, initialSelectedIds, initialTab, onClose, onApply }: AddFilesMatterFilesDialogProps) {
  // AddFilesModal requires a non-null matterId; there is nothing to browse without one.
  if (!matterId) return null

  return (
    <AddFilesModal
      open={open}
      matterId={matterId}
      initialSelectedFileIds={initialSelectedIds}
      initialTab={initialTab}
      onClose={onClose}
      onFilesSelected={onApply}
      isFileSelectable={(file) => file.detected_content_type === 'application/pdf'}
      fileNotSelectableMessage={kPdfOnlyFileTypeMessage}
    />
  )
}
